/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BeamAnalysisCorrectionsDto } from './BeamAnalysisCorrectionsDto';
import {
    instanceOfBeamAnalysisCorrectionsDto,
    BeamAnalysisCorrectionsDtoFromJSON,
    BeamAnalysisCorrectionsDtoFromJSONTyped,
    BeamAnalysisCorrectionsDtoToJSON,
} from './BeamAnalysisCorrectionsDto';

/**
 * @type BeamAnalysisTaskItemAreaDataDtoCorrections
 * 
 * @export
 */
export type BeamAnalysisTaskItemAreaDataDtoCorrections = BeamAnalysisCorrectionsDto;


export function BeamAnalysisTaskItemAreaDataDtoCorrectionsFromJSON(json: any): BeamAnalysisTaskItemAreaDataDtoCorrections {
    return BeamAnalysisTaskItemAreaDataDtoCorrectionsFromJSONTyped(json, false);
}

export function BeamAnalysisTaskItemAreaDataDtoCorrectionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamAnalysisTaskItemAreaDataDtoCorrections {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...BeamAnalysisCorrectionsDtoFromJSONTyped(json, true) };
    return  BeamAnalysisCorrectionsDtoFromJSONTyped(json, true);
}

export function BeamAnalysisTaskItemAreaDataDtoCorrectionsToJSON(value?: BeamAnalysisTaskItemAreaDataDtoCorrections | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfBeamAnalysisCorrectionsDto(value)) {
        return BeamAnalysisCorrectionsDtoToJSON(value as BeamAnalysisCorrectionsDto);
    }

    return {};
}

/**
 * Check if a given object implements the BeamAnalysisTaskItemAreaDataDtoCorrections interface.
 */
export function instanceOfBeamAnalysisTaskItemAreaDataDtoCorrections(value: any): value is BeamAnalysisTaskItemAreaDataDtoCorrections {
    if (instanceOfBeamAnalysisCorrectionsDto(value)) return true;
    return false;
}

